<template>
  <div id="app">
    <md-card md-with-hover>
      <md-card-header>
        <div class="md-title"> {{ card.title }} </div>
        <div class="md-subhead"> {{ card.subTitle }} </div>
      </md-card-header>
      <md-card-content>
       	      <md-input-container id="newTaskContainer">
              <md-field>
                <md-input ref="newTask" id="newTask" v-model="newTask" @keyup.enter.native="addTask()" placeholder="What needs to be done?"></md-input>
              </md-field>
            </md-input-container>   
          <md-list>
          <md-list-item v-for="(task, index) in tasks" :key="task.id">
            <div v-show="task.edit == false" v-bind:class="klass(task.completed)">
              <label @dblclick="task.edit=true"> {{task.text}} </label>
            </div>
            <input v-show="task.edit == true" v-model="task.text"
                        v-on:blur= "task.edit=false; $emit('update')"
                        @keyup.enter="task.edit=false; $emit('update')" />
            <md-checkbox ref="markTaskAsComplete" id="markTaskAsComplete" v-model="task.completed"></md-checkbox>
          </md-list-item>
        </md-list>
        <md-button class="md-raised md-primary" @click.native="completeAll()"> Mark all as completed </md-button>
        <md-button class="md-raised md-primary" @click.native="clearList()"> Clear List </md-button>
      </md-card-content>
    </md-card> 
    <p> Double click to edit an existing todo </p>
  </div>
</template>

<script>
export default {
  name: "App",
  data: function() {
    return {
      title: "",
      card: {
        title: "A simple todo list using Vue material",
        subTitle: "by Salma Sultana"
      },
      tasks: [
        {
          id:0,
          text:"Add your first todo",
          completed: false,
          edit: false
        },
      ],
      newTask: "",
      nextId: 1,
     }
  },
  methods: {
    addTask: function() {
      if (this.newTask.trim() === "")
        return;
      this.tasks.push(
        {
          id: this.nextId,
          text: this.newTask,
          completed: false,
          edit: false
        }
      );
      this.newTask = "";
      this.nextId++;
    },
    completeAll: function () {
      for (const task of this.tasks)
        task.completed = true;
    },
    clearList: function () {
      this.tasks.splice(0,this.tasks.length);
    },
    klass(completed) {
      return completed ? "strike-through" : "";
    },
    mounted: function() {
      this.$nextTick(function () {
        var newTask = document.getElementById("newTask");
        newTask.focus();
      })
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2C3539;
  margin-top: 60px;
}
.md-card {
  width: 500px;
  margin: 3px;
  display: inline-block;
  vertical-align: center;
  color:#2C3539;
}
.md-input {
  text-align:center;
}
.strike-through {
  text-decoration: line-through;
}
.
.p {
text-align:absolute-center;
display:inline-block;
}
</style>



// WEBPACK FOOTER //
// src/App.vue